export enum AccountType{
    CLIENT='client',
    kIOSQUE='kiosque',
    KIOSQUE_AGENT='kiosque_agent',
    BUSINESS='business',
    BUSINESS_AGENT='business_agent'
}